import CTab from './CTab'
import CTabs from './CTabs'

export {
  CTab,
  CTabs
}
